// One-finger, horizontal intent only. A vertical scroll never becomes a swipe.
export function beginDaySwipe(touch, now = Date.now()) {
    return {x:touch.clientX, y:touch.clientY, dx:0, at:now, axis:null};
}
export function moveDaySwipe(gesture, touch) {
    if (!gesture) return false;
    const dx = touch.clientX-gesture.x, dy = touch.clientY-gesture.y;
    gesture.dx = dx;
    if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
        gesture.axis = Math.abs(dx) > Math.abs(dy)*1.7 ? 'horizontal' : 'vertical';
    }
    return gesture.axis === 'horizontal';
}
export function finishDaySwipe(gesture, now = Date.now()) {
    return gesture?.axis === 'horizontal' && Math.abs(gesture.dx) >= 60 && now-gesture.at <= 900
        ? (gesture.dx < 0 ? 1 : -1) : 0;
}
